/* Package JSON Import will be here */
import React, { useState, useEffect } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from 'react-redux';
import { filter, includes, isEmpty } from "lodash";
import { Row, Col, Checkbox, Radio, Slider, Avatar, Input, Divider, Modal } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import Constants from "utilities/appConstants";
import NoData from "components/reusable/NoData";
import TooltipComp from "components/reusable/TooltipComp";
import { onChangeFilterData, onChangeAttrSortData } from "reducers/filter/attrFilter";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { confirm } = Modal;
/* Const,Let & Var will be here */

const AttrFilterTemplate = (props) => {
    const [searchText, setSearchText] = useState("");

    const { translate, attrFilter, appSettings } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        appSettings: state.appSettings,
        attrFilter: state.attrFilter
    }));

    const dispatch = useDispatch();

    useEffect(() => {
        setSearchText("");
    }, [props.attrId]);

    const getSelectedAttr = (attrId) => {
        const selectedAttr = filter(attrFilter.selectedAttrFilter, (o) => {
            return o.AttrId === attrId;
        })[0];

        return selectedAttr;
    }
    const onChangeSortFilter = (e) => {
        const sortExist = filter(attrFilter.selectedAttrFilter, (o) => {
            return o.Sorting === Constants.NAME_ASC || o.Sorting === Constants.NAME_DESC;
        })[0];

        if (sortExist && (props.attrId !== sortExist.AttrId)) {

            /*  conformation PopUp for change, applied sort attribute  */
            return (
                confirm({
                    title: translate("common.alerts.confirmation.sortingFilterExist"),
                    okText: translate("common.buttons.ok"),
                    cancelText: translate("common.buttons.cancel"),
                    okButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
                    cancelButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
                    centered: true,
                    onOk: async () => {
                        dispatch(onChangeAttrSortData(props.attrId, e.target.value));
                    }
                })
            )
        }
        else
            dispatch(onChangeAttrSortData(props.attrId, e.target.value));
    }

    const isCheckBoxSelected = (attrId, attrValueId) => {
        if (attrFilter.selectedAttrFilter.length > 0) {
            const selectedAttrData = getSelectedAttr(attrId);

            if (selectedAttrData !== undefined) {
                return includes(selectedAttrData.AttrValues, attrValueId);
            }
        }
        else {
            return false;
        }
    }

    const isRadioBoxSelected = (attrId) => {
        if (attrFilter.selectedAttrFilter.length > 0) {
            const selectedAttrData = getSelectedAttr(attrId);

            if (selectedAttrData !== undefined) {
                return selectedAttrData.AttrValues[0];
            }
        }
        return 0;
    }

    const isSortingFilterSelected = (attrId) => {
        if (attrFilter.selectedAttrFilter.length > 0) {
            const selectedAttrData = getSelectedAttr(attrId);

            if (selectedAttrData !== undefined)
                return selectedAttrData.Sorting;
        }
        return 0;
    }

    const getSelectedRangeValue = (attrId) => {
        if (attrFilter.selectedAttrFilter.length > 0) {
            const selectedAttrData = getSelectedAttr(attrId);

            if (selectedAttrData !== undefined) {
                return selectedAttrData.AttrRangeValues;
            }
        }

        return [0, 0];
    }


    const getColorElement = (colorCode) => {
        return (
            <Avatar style={{ backgroundColor: colorCode, verticalAlign: 'middle' }} size="small" />
        );
    }

    const getImageElement = (imageUrl) => {
        return (
            <Avatar src={imageUrl} />
        );
    }

    const searchAttrValue = (e) => {
        setSearchText(e.target.value)
    }

    const checkAttrValuesAvailable = () => {
        const selectedAttrData = getSelectedAttrInfo(props.attrId);

        if (selectedAttrData !== undefined)
            return selectedAttrData.AttrValues.length > 0 ? true : false;
        else
            return false;
    }

    const isShowSortingFilter = (attrId) => {
        const attrData = getSelectedAttrInfo(attrId);
        if (attrData !== undefined && attrData.AttrSorting && attrData.AttrValues.length > 0 && attrData.SelectionType !== Constants.RANGE)
            return true;
        else
            return false;
    }

    const getSelectedAttrInfo = (attrId) => {
        const data = filter(attrFilter.data, (o) => {
            return o.AttrId === attrId;
        })[0];

        return data;
    }

    /* Bind the right side attr value items */
    const bindSelectedAttrValueList = (attrId) => {
        const selectedAttrData = getSelectedAttrInfo(attrId);

        const filteredAttrValueList = filter(selectedAttrData.AttrValues, (o) => {
            return o.AttrValueName.toLowerCase().includes(searchText.toLowerCase());
        });

        if (selectedAttrData !== undefined && filteredAttrValueList !== undefined && (filteredAttrValueList.length > 0 || !isEmpty(selectedAttrData.Range))) {
            if (selectedAttrData.SelectionType === Constants.MULTIPLE) {
                return (
                    <React.Fragment>
                        <div className="p-1">
                            {filteredAttrValueList.map((item) => {
                                return (
                                    <div className={props.pageType === Constants.ATTR_MOBILE ? "p-2" : ""} key={item.AttrValueId}>
                                        <Row>
                                            {item.ColorCode !== null &&
                                                <Col span={4}>
                                                    {getColorElement(item.ColorCode)}
                                                </Col>
                                            }
                                            {item.ImageUrl !== null &&
                                                <Col span={4}>
                                                    {getImageElement(item.ImageUrl)}
                                                </Col>
                                            }
                                            <Col span={(item.ColorCode !== null || item.ImageUrl !== null) ? 20 : 24}>
                                                <Checkbox
                                                    checked={isCheckBoxSelected(attrId, item.AttrValueId)}
                                                    onChange={() => dispatch(onChangeFilterData(attrId, item.AttrValueId, Constants.MULTIPLE))}
                                                    className={`attr-value-checkbox w-100 responsive-font-size text-truncate ${props.pageType === Constants.ATTR_WEB && "pt-1"}`}
                                                >
                                                    {item.AttrValueName}
                                                </Checkbox>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            })}
                        </div>
                    </React.Fragment>
                );
            }
            else if (selectedAttrData.SelectionType === Constants.SINGLE) {
                return (
                    <React.Fragment>
                        <div className="p-1">
                            <Radio.Group
                                onChange={(e) => dispatch(onChangeFilterData(attrId, e.target.value, Constants.SINGLE))}
                                value={isRadioBoxSelected(attrId)}
                                className="w-100"
                            >
                                {filteredAttrValueList.map((item) => {
                                    return (
                                        <Row key={item.AttrValueId} className="p-2">
                                            {item.ColorCode !== null &&
                                                <Col span={4}>
                                                    {getColorElement(item.ColorCode)}
                                                </Col>
                                            }
                                            {item.ImageUrl !== null &&
                                                <Col span={4}>
                                                    {getImageElement(item.ImageUrl)}
                                                </Col>
                                            }
                                            <Col span={(item.ColorCode !== null || item.ImageUrl !== null) ? 20 : 24}>
                                                <Radio
                                                    className="attr-value-radio w-100 responsive-font-size text-truncate"
                                                    value={item.AttrValueId}
                                                >
                                                    {item.AttrValueName}
                                                </Radio>
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </Radio.Group>
                        </div>
                    </React.Fragment>
                );
            }
            else if (selectedAttrData.SelectionType === Constants.RANGE) {
                return (
                    <React.Fragment>
                        <Row className="p-2">
                            <Col className="text-center p-1 w-100">
                                {translate("filter.attrFilter.selectedMinRange")} : {getSelectedRangeValue(attrId)[0]}
                            </Col>
                            <Col className="text-center p-1 w-100">
                                {translate("filter.attrFilter.selectedMaxRange")} : {getSelectedRangeValue(attrId)[1]}
                            </Col>
                        </Row>
                        <div className="p-2">
                            <Slider
                                min={selectedAttrData.Range.min}
                                max={selectedAttrData.Range.max}
                                step={selectedAttrData.Range.interval}
                                range
                                defaultValue={getSelectedRangeValue(attrId)}
                                onChange={(value) => dispatch(onChangeFilterData(attrId, value, Constants.RANGE))}
                            />
                        </div>
                    </React.Fragment>
                );
            }
        }
        else {
            return (
                <React.Fragment>
                    <div className="container pt-2">
                        <NoData NoDataMessage={translate("filter.attrFilter.noData")} />
                    </div>
                </React.Fragment>
            );
        }
    };

    return (
        <React.Fragment>
            {(appSettings.isEnableAttrSorting && isShowSortingFilter(props.attrId)) &&
                <React.Fragment>
                    {/*  Sorting filter attribute  */}
                    <Row className="attr-sorting-filter">
                        <Col span={10} className="p-1 text-center">
                            <span className="font-bold">{translate("filter.sortingFilter.sortBy")}</span>
                        </Col>
                        <Col span={14} className="p-1">
                            <Radio.Group
                                onChange={(e) => onChangeSortFilter(e)}
                                value={isSortingFilterSelected(props.attrId)}
                                className="w-100">
                                <Row>
                                    <Col span={12}>
                                        <Radio value={Constants.NAME_ASC}>
                                            <TooltipComp title={translate("filter.sortingFilter.sortByAscending")}>
                                                {<i className="fa fa-sort-amount-asc font-20" aria-hidden="true">
                                                </i>}
                                            </TooltipComp></Radio>
                                    </Col>
                                    <Col span={12}>
                                        <Radio value={Constants.NAME_DESC}>
                                            <TooltipComp title={translate("filter.sortingFilter.sortByDescending")}>
                                                {<i className="fa fa-sort-amount-desc font-20" aria-hidden="true">
                                                </i>}
                                            </TooltipComp></Radio>
                                    </Col>
                                </Row>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Divider />
                </React.Fragment>
            }

            {checkAttrValuesAvailable() &&
                /* Search input */
                <Row>
                    <Col span={24} className="p-2">
                        <Input
                            className="round-radius"
                            placeholder={translate("filter.attrFilter.searchPlaceholder")}
                            suffix={<i className="fa fa-search" aria-hidden="true"></i>}
                            onChange={searchAttrValue}
                            value={searchText}
                        />
                    </Col>
                </Row>
            }

            {bindSelectedAttrValueList(props.attrId)}
        </React.Fragment >
    );
}

export default AttrFilterTemplate;